'use client';

import { useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { env } from '@/env';
import { cookies } from '@/lib/jucyCookies';
import { CmsPage } from '@/services/cms/pages/CmsPage';

export interface CommissionJunctionProps {
    pageData?: CmsPage;
    pageSlug?: string[];
    enterpriseId?: number;
}

export const CommissionJunction = (props: CommissionJunctionProps) => {
    const cjPageType = cmsPageTypeToCjPageType(props);
    const query = useSearchParams();
    if (query?.get('cjevent')) {
        cookies.set('cje', query.get('cjevent'));
    }

    return (
        <Script id="commission-junction-loader" strategy="afterInteractive">{`
    if (!window.cj) {  
        window.cj = {};
    }
    cj.sitePage = {
        enterpriseId: ${env.NEXT_PUBLIC_CJ_ENTERPRISE_ID},
        pageType: '${cjPageType}'
    };

    (function(a,b,c,d){
        a='/proxydirectory/tags/203707878328/tag.js';
        b=document;c='script';d=b.createElement(c);d.src=a;
        d.type='text/java'+c;d.async=true;
        d.id='cjapitag';
        a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a)
    })();
    `}</Script>
    );
};

const cmsPageTypeToCjPageType = ({ pageData, pageSlug }: CommissionJunctionProps) => {
    if (!pageSlug) {
        return 'homepage';
    }
    if (pageData?.className === 'FleetCategoryPage') {
        return 'productDetail';
    }
    if (pageData?.className === 'FleetTypePage') {
        return 'category';
    }
    return 'information';
};
